export default __webpack_public_path__ + "static/media/note-green.c6e14d44.svg";